import { useNavigate } from 'react-router-dom';

import { OrderCompanyId, OrderValidateParams } from '~services/order/types';
import { useRequest } from '~hooks/index';
import { getCompanyIdByTrackingCode } from '~services/order';

interface SearchAndRedirectOrderByTrackingCodeParams {
  trackingCode: string;
  getUrlRedirect: (data: OrderValidateParams) => string;
}

interface SearchAndRedirectOrderByTrackingCodeReturn {
  loading: boolean;
  notFound: boolean;
}

export const useSearchAndRedirectOrderByTrackingCode = ({
  trackingCode,
  getUrlRedirect,
}: SearchAndRedirectOrderByTrackingCodeParams): SearchAndRedirectOrderByTrackingCodeReturn => {
  const navigate = useNavigate();

  const [, loading, error] = useRequest({
    request: getCompanyIdByTrackingCode,
    payload: trackingCode,
    withPostSuccess: (response) => {
      const { companyId } = response.data?.data as OrderCompanyId;

      const urlRedirect = getUrlRedirect({ companyId, trackingCode });

      navigate(urlRedirect);
    },
  });

  return { loading, notFound: Boolean(error) };
};
